/** Worker Protocol AI-chat complete payload is `{status, results:[{type,text}]}`.
 * Older/local shapes may expose a top-level `text`. Direct Test RESULT SUMMARY
 * must read the real stored reply — never invent or reuse another job's text. */
export function extractDirectTestResultSummary(result: Record<string, unknown> | null | undefined): string | null {
  if (!result || typeof result !== 'object') return null
  const top = result.text
  if (typeof top === 'string' && top.trim()) return top
  const results = result.results
  if (!Array.isArray(results)) return null
  for (const item of results) {
    if (!item || typeof item !== 'object') continue
    const text = (item as Record<string, unknown>).text
    if (typeof text === 'string' && text.trim()) return text
  }
  return null
}
